import React, { Component } from "react";
import { withTranslation } from "react-i18next";
class Configurator extends Component {
  state = {};
  render() {
    const { t } = this.props;
    return (
      <section>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div
              className="col-10 col-lg-10 col-md-10 md-margin-7-rem-bottom wow animate__fadeInLeft"
              data-wow-delay="0.5s"
              style={{
                visibility: "visible",
                animationDelay: "0.5s",
                animationName: "fadeInLeft",
              }}
            >
              <h2 className="alt-font font-weight-600 text-extra-dark-gray w-95 mb-4">{t("title205")}</h2>
              <p className="text-extra-large-2 text-extra-dark-gray font-weight-500 margin-5px-bottom d-block">
                {t("text33")}
              </p>
              <br />
              <p className="text-extra-medium text-extra-dark-gray font-weight-600 margin-5px-bottom d-none">&nbsp;</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withTranslation("general")(Configurator);
